/** @jsxImportSource jsx-dom */
import { Logger, select, selectAll } from "@fruugo/utilities";
import { getHomepageHeroData } from "./api";
import { createPictureElement } from "./utilities";
import Glide, { Controls, Swipe } from "@glidejs/glide/dist/glide.modular.esm";
import { heroImagesSizes, imageFormats } from "../config";
var Log = new Logger(window.environment);
export default function initHomeBanner() {
    var banner = select("#cms-hero");
    if (!banner)
        return;
    getHomepageHeroData(heroImagesSizes.join(","), imageFormats.join(","))
        .then(function (data) {
        if (data.theme === null || data.items === null)
            return;
        updateBanner(banner, data.items);
        initBannersHero(banner);
    })
        .catch(function (error) { return Log.error(error); });
}
function updateBanner(banner, banners) {
    var wrapper = banner.querySelector(".glide__slides");
    var template = banner.querySelector(".glide__slide");
    if (!wrapper || !template)
        return;
    banners.slice(0, 5).forEach(function (banner) {
        var slide = createHero(banner, template.cloneNode(true));
        wrapper === null || wrapper === void 0 ? void 0 : wrapper.appendChild(slide);
    });
    template === null || template === void 0 ? void 0 : template.remove();
}
function createHero(item, template) {
    var element = template;
    var inner = element.querySelector(".Home__Hero__ItemInner");
    var title = element.querySelector(".Home__Hero__ItemInner__Title");
    var description = element.querySelector("p");
    var hidden = element.querySelector(".d-none");
    if (inner)
        inner.classList.remove("bg-transparent");
    var picture = createPictureElement(item.imageUrl, item.imageSizes, item.title, "Home__Hero__Item__Image", true);
    element.appendChild(picture);
    if (title)
        title.textContent = item.title;
    if (description)
        description.textContent = item.subtitle;
    if (hidden)
        hidden.classList.remove("d-none");
    element.setAttribute("href", item.cta.href);
    return element;
}
function initBannersHero(banner) {
    showArrows();
    return new Glide(banner, {
        type: "carousel",
        perView: 1,
        animationDuration: 600,
        direction: window.rtl ? "rtl" : "ltr",
        gap: 0,
        dragThreshold: false,
    }).mount({ Controls: Controls, Swipe: Swipe });
}
function showArrows() {
    var arrows = selectAll("#cms-hero .glide__arrow");
    if (arrows && arrows.length > 0) {
        arrows.forEach(function (arrow) { return arrow.classList.add("d-lg-block"); });
    }
}
